import { NativeModule } from "expo";

import type { ExpoTvConnectHostModuleEvents } from "./ExpoTvConnectHost.types";

class ExpoTvConnectHostModule extends NativeModule<ExpoTvConnectHostModuleEvents> {
  configure(): void {
    throw new Error("Not supported on this platform");
  }

  async startHosting(): Promise<void> {
    throw new Error("Not supported on this platform");
  }

  async stopHosting(): Promise<void> {
    throw new Error("Not supported on this platform");
  }

  send(): void {
    throw new Error("Not supported on this platform");
  }

  broadcast(): void {
    throw new Error("Not supported on this platform");
  }

  acceptRemote(): void {
    throw new Error("Not supported on this platform");
  }

  rejectRemote(): void {
    throw new Error("Not supported on this platform");
  }
}

export default new ExpoTvConnectHostModule();
